import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a6fd80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "closefriend-hero background-white" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row p-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12" })
], -1))
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "text-center col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_6 = { class: "create-custom-title text-left tag_1" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_9 = { class: "login-card" }
const _hoisted_10 = { class: "login-body personal" }
const _hoisted_11 = { class: "row mt-5" }
const _hoisted_12 = { class: "col-md-12 col-12 col-lg-12" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Account application type", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Individual Application", -1))
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = {
  key: 0,
  class: "col-md-12 col-12 col-lg-12"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company type", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian Domestic Company", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "ASIC registered Non-Australian Company", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Non-Australian Company", -1))
const _hoisted_32 = { class: "col-md-12 col-12 col-lg-6" }
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "First name", -1))
const _hoisted_35 = { class: "col-md-12 col-12 col-lg-6" }
const _hoisted_36 = { class: "form-group" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Last name", -1))
const _hoisted_38 = { class: "col-md-12 col-12 col-lg-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email ID", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ca5959!important"} }, " **Do not use personal email for corporate application", -1))
const _hoisted_43 = { class: "col-md-12 col-12 col-lg-6" }
const _hoisted_44 = { class: "form-group" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Mobile/Cell Number ", -1))
const _hoisted_46 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2" }
const _hoisted_47 = { class: "row justify-content-center mx-md-0 mx-1 mb-5" }
const _hoisted_48 = { class: "col-md-12 col-12 px-1" }
const _hoisted_49 = { class: "text-muted text-center mt-3" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "subBtn",
  type: "submit",
  class: "btn btn-success btn-mobile btn-lg btn-block mt-3 btn-mobile font-size-15-18"
}, " Get Started ", -1))
const _hoisted_51 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_52 = { class: "modal-dialog" }
const _hoisted_53 = { class: "modal-content" }
const _hoisted_54 = { class: "modal-header" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, "Please fix this", -1))
const _hoisted_56 = { class: "modal-body" }
const _hoisted_57 = {
  key: 0,
  ref: "errorBlock",
  id: "errorBlock"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_toast = _resolveComponent("toast")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_Form, {
          method: "POST",
          ref: "signupform",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.submitForm
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h1", _hoisted_6, [
                  _createTextVNode(" Open Account "),
                  _createVNode(_component_router_link, {
                    class: "login_title",
                    to: "/sign-in"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Login ? ")
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _hoisted_14,
                          _createVNode(_component_Field, {
                            style: {"font-size":"18px!important"},
                            modelValue: _ctx.form.applicant_type,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.applicant_type) = $event)),
                            id: "applicant_type",
                            class: "form-control",
                            name: "applicant_type",
                            as: "select",
                            rules: _ctx.selectField
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: ""
                              }, "Please select", 8, _hoisted_15),
                              _hoisted_16,
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "2"
                              }, "Corporate Application", 8, _hoisted_17),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "3"
                              }, "Trust Application", 8, _hoisted_18),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "4"
                              }, "Agents Application", 8, _hoisted_19),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "5"
                              }, "Association Application", 8, _hoisted_20),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "6"
                              }, "Government Bodies Application", 8, _hoisted_21),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "7"
                              }, "Partnership Application", 8, _hoisted_22),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "8"
                              }, "Registered Co-Operative Application", 8, _hoisted_23),
                              _createElementVNode("option", {
                                disabled: 'disabled'?(_ctx.form.is_director==1 || _ctx.form.is_partner==1):'',
                                value: "9"
                              }, "Politically Exposed Persons Application", 8, _hoisted_24)
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "applicant_type"
                          })
                        ])
                      ]),
                      (_ctx.form.applicant_type==2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createVNode(_component_Field, {
                                style: {"font-size":"18px!important"},
                                modelValue: _ctx.form.company_type,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.company_type) = $event)),
                                id: "company_type",
                                class: "form-control",
                                name: "company_type",
                                as: "select",
                                rules: _ctx.selectField
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_28,
                                  _hoisted_29,
                                  _hoisted_30,
                                  _hoisted_31
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"]),
                              _createVNode(_component_ErrorMessage, {
                                style: {"color":"#d00000"},
                                name: "company_type"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_Field, {
                        modelValue: this.active_tab,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.active_tab) = $event)),
                        name: "user_type",
                        id: "user_type",
                        type: "hidden"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.first_name,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.first_name) = $event)),
                            placeholder: "ie. John",
                            class: "form-control selected-field",
                            name: "first_name",
                            id: "first_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "first_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.last_name,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.last_name) = $event)),
                            placeholder: "ie. Doe",
                            class: "form-control selected-field",
                            name: "last_name",
                            id: "last_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "last_name"
                          })
                        ])
                      ]),
                      _createVNode(_component_Field, {
                        type: "hidden",
                        name: "is_director",
                        modelValue: _ctx.form.is_director,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.is_director) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Field, {
                        type: "hidden",
                        name: "director_id",
                        modelValue: _ctx.form.director_id,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.director_id) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Field, {
                        type: "hidden",
                        name: "is_partner",
                        modelValue: _ctx.form.is_partner,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.is_partner) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_Field, {
                        type: "hidden",
                        name: "partner_id",
                        modelValue: _ctx.form.partner_id,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.partner_id) = $event))
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _hoisted_40,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.user_email,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.user_email) = $event)),
                            placeholder: "ie. example@mail.com",
                            class: "form-control selected-field",
                            name: "user_email",
                            id: "user_email",
                            type: "email",
                            rules: _ctx.validateEmail
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "user_email"
                          }),
                          _createTextVNode(),
                          _hoisted_41,
                          _hoisted_42
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.phone_no,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.phone_no) = $event)),
                            placeholder: "ie. +1 111 1515451",
                            class: "form-control selected-field",
                            name: "phone_no",
                            id: "phone_no",
                            type: "text",
                            rules: _ctx.mobileField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "phone_no"
                          })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, [
                      _createTextVNode("© Caprock Limited (AFSL 330742) I "),
                      _createVNode(_component_router_link, {
                        target: "_blank",
                        to: "terms-of-use",
                        class: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Terms of Service ")
                        ]),
                        _: 1
                      }),
                      _createTextVNode(" and "),
                      _createVNode(_component_router_link, {
                        target: "_blank",
                        to: "privacy-policy",
                        class: "success"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Privacy Policy ")
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_50
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeModal('exampleModal'))),
              class: "btn btn-secondary",
              "data-mdb-dismiss": "modal"
            }, " Close ")
          ]),
          _createElementVNode("div", _hoisted_56, [
            (_ctx.errors.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, key) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: key,
                      class: "alert alert-danger"
                    }, _toDisplayString(error), 1))
                  }), 128))
                ], 512))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_toast, { ref: "toast" }, null, 512)
  ], 64))
}